export function centsToDollars(cents: number | null | undefined): number {
  if (cents == null) return 0;
  return cents / 100;
}

export function formatMoneyShort(cents: number): string {
  const dollars = centsToDollars(cents);
  if (dollars >= 1000) return `$${(dollars / 1000).toFixed(1)}k`;
  return `$${Math.round(dollars).toLocaleString()}`;
}

export function parseProductionCents(value: string | number | undefined): number | undefined {
  if (value == null || value === '') return undefined;
  if (typeof value === 'number') return Number.isFinite(value) ? Math.round(value) : undefined;
  const parsed = Number.parseFloat(value);
  if (!Number.isFinite(parsed)) return undefined;
  return Math.round(parsed * 100);
}

export function normalizeCamelCase<T>(payload: T): T {
  return payload;
}
